import VConsole from "vconsole";

export default defineNuxtPlugin(() => {
  const isDev =
    import.meta.env.VITE_DEV_ENV === "true" ||
    window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1";

  if (isDev) {
    new VConsole();
  }
});
